const RESERVATION_TYPES = ["일반", "학단", "통근", "투어"];

const TYPE_ALIASES = [
  { type: "통근", words: ["통근", "출퇴근", "셔틀"] },
  { type: "학단", words: ["학단", "학교", "학생", "수학여행"] },
  { type: "투어", words: ["투어", "관광", "여행"] },
  { type: "일반", words: ["일반"] },
];

const CHANGE_WORDS = ["바꿔", "변경", "대체", "교체", "재배정", "다른 기사", "다른기사"];
const LEAVE_WORDS = ["아파", "병원", "병가", "휴무", "못 나", "못나", "사고", "경조"];
const SAFETY_ISSUES = ["민원", "사고", "과태료"];
const SEARCH_WORDS = ["찾아", "검색", "조회", "보여", "불러", "가져와"];
const VEHICLE_UPDATE_FIELDS = [
  { key: "car_number", labels: ["차량번호", "차량 번호", "차 번호", "차번호"] },
  { key: "car_name", labels: ["차명", "차 이름", "차량명", "차량 이름"] },
  { key: "driver", labels: ["기사명", "기사 이름", "기사", "운전자"] },
  { key: "phone", labels: ["핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "전화번호", "연락처"] },
  { key: "year", labels: ["년식", "연식"] },
  { key: "driver_email", labels: ["기사 이메일", "기사메일", "기사 메일", "이메일", "메일"] },
  { key: "seat", labels: ["승차인원", "승차 인원", "좌석", "인승"] },
  { key: "career", labels: ["경력사항", "경력 사항", "경력"] },
];
const DRIVER_UPDATE_FIELDS = [
  { key: "driver_name", labels: ["기사명", "기사 이름", "운전자명", "운전자 이름"] },
  { key: "email", labels: ["기사 이메일", "기사메일", "기사 메일", "이메일", "메일"] },
  { key: "phone", labels: ["기사 전화번호", "기사전화번호", "핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "전화번호", "연락처"] },
];
const DRIVER_CREATE_FIELDS = [
  ...DRIVER_UPDATE_FIELDS,
  { key: "career", labels: ["경력사항", "경력 사항", "경력"] },
];
const USER_CREATE_FIELDS = [
  { key: "name", labels: ["이름", "사용자명", "사용자 이름"] },
  { key: "user_id", labels: ["사용자 아이디", "사용자 ID", "사용자 id", "아이디", "ID", "id"] },
  { key: "password", labels: ["비밀번호", "패스워드", "비번"] },
  { key: "branch", labels: ["지점명", "지점"] },
  { key: "team", labels: ["팀명", "팀"] },
  { key: "position", labels: ["직위명", "직위"] },
  { key: "email", labels: ["이메일", "메일", "Email", "email"] },
  { key: "phone", labels: ["전화번호", "전화", "핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "연락처"] },
  { key: "address", labels: ["주소"] },
  { key: "system", labels: ["사용 시스템", "시스템", "권한"] },
];
const EXPENSE_FIELD_LABELS = [
  { key: "johab", labels: ["조합비"] },
  { key: "unyoung", labels: ["운영비"] },
  { key: "gps", labels: ["GPS", "지피에스"] },
  { key: "halbu", labels: ["할부금", "할부"] },
  { key: "geubyeo", labels: ["급여"] },
  { key: "bohum", labels: ["보험료", "보험"] },
  { key: "sooksic", labels: ["숙식비", "숙박비", "식비"] },
  { key: "jungbi", labels: ["정비비", "정비"] },
  { key: "jooyu", labels: ["주유비", "주유"] },
  { key: "secha", labels: ["세차료", "세차비", "세차"] },
  { key: "4bohum", labels: ["4대보험", "4대 보험", "4 대 보험", "사대보험", "사대 보험"] },
  { key: "tonghaeng", labels: ["통행료", "통행비"] },
  { key: "joocha", labels: ["주차료", "주차비", "주차"] },
  { key: "chooljang", labels: ["출장비", "출장"] },
  { key: "gwatae", labels: ["과태료"] },
  { key: "gita", labels: ["기타비", "기타"] },
];

function pad2(value) {
  return String(value).padStart(2, "0");
}

function formatDate(date) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

function addDays(baseDate, days) {
  const next = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  next.setDate(next.getDate() + days);
  return next;
}

function normalizeText(text = "") {
  return String(text).replace(/\s+/g, " ").trim();
}

function cleanTrailingParticle(value = "") {
  return String(value || "")
    .replace(/\s*(?:이고|이야|야|입니다|이에요|예요|로|으로|은|는|을|를|가|이)\s*$/g, "")
    .trim();
}

export function parseKoreanDate(text = "", baseDate = new Date()) {
  const raw = normalizeText(text);

  const iso = raw.match(/(20\d{2})[-./년\s]+(\d{1,2})[-./월\s]+(\d{1,2})/);
  if (iso) {
    return `${iso[1]}-${pad2(iso[2])}-${pad2(iso[3])}`;
  }

  if (/모레|내일모레/.test(raw)) return formatDate(addDays(baseDate, 2));
  if (/내일/.test(raw)) return formatDate(addDays(baseDate, 1));
  if (/오늘/.test(raw)) return formatDate(addDays(baseDate, 0));
  if (/어제/.test(raw)) return formatDate(addDays(baseDate, -1));

  const monthDay = raw.match(/(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
  if (monthDay) {
    return `${baseDate.getFullYear()}-${pad2(monthDay[1])}-${pad2(monthDay[2])}`;
  }

  const dayOnly = raw.match(/(?:^|\s)(\d{1,2})\s*일(?:\s|$)/);
  if (dayOnly) {
    return `${baseDate.getFullYear()}-${pad2(baseDate.getMonth() + 1)}-${pad2(dayOnly[1])}`;
  }

  return "";
}

export function parseKoreanTime(text = "") {
  const raw = normalizeText(text);

  const colon = raw.match(/([01]?\d|2[0-3])\s*:\s*([0-5]\d)/);
  if (colon) return `${pad2(colon[1])}:${colon[2]}`;

  const ampm = raw.match(/(오전|오후|아침|저녁|밤)?\s*(\d{1,2})\s*시(?:\s*(\d{1,2})\s*분)?/);
  if (!ampm) return "";

  let hour = Number(ampm[2]);
  const minute = Number(ampm[3] || 0);
  const marker = ampm[1] || "";

  if ((marker === "오후" || marker === "저녁" || marker === "밤") && hour < 12) hour += 12;
  if (marker === "오전" && hour === 12) hour = 0;

  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return "";
  return `${pad2(hour)}:${pad2(minute)}`;
}

export function parseReservationType(text = "") {
  const raw = normalizeText(text);
  for (const entry of TYPE_ALIASES) {
    if (entry.words.some((word) => raw.includes(word))) return entry.type;
  }
  return "";
}

function parseMoney(text = "") {
  const raw = normalizeText(text).replace(/,/g, "");
  const man = raw.match(/(\d+)\s*만\s*원?/);
  if (man) return Number(man[1]) * 10000;

  const won = raw.match(/(\d{4,})\s*원?/);
  if (won) return Number(won[1]);

  return "";
}

function toMoneyAmount(numberText = "", hasMan = false) {
  const value = Number(String(numberText || "").replace(/,/g, ""));
  if (!Number.isFinite(value)) return 0;
  return hasMan ? value * 10000 : value;
}

function parseLabeledMoney(text = "", labels = []) {
  const raw = normalizeText(text).replace(/만원/g, "만 원");
  for (const label of labels) {
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp(`${escaped}\\s*(?:은|는|이|가|을|를|:|：)?\\s*([0-9,]+)\\s*(만)?\\s*원?`);
    const match = raw.match(re);
    if (match) return toMoneyAmount(match[1], !!match[2]);
  }
  return 0;
}

function parseUserPhone(text = "") {
  const raw = normalizeText(text);
  const phone = raw.match(/(?:사용자\s*)?(?:전화번호|연락처|핸드폰|휴대폰)\s*(?:은|는|:|：)?\s*(01[016789][-\s]?\d{3,4}[-\s]?\d{4})/);
  return phone ? phone[1].replace(/\s+/g, "") : "";
}

function parseSeatDetail(text = "") {
  const raw = normalizeText(text);
  const seat = raw.match(/(\d{1,2})\s*인\s*승/);
  if (seat) return `${seat[1]}인승`;
  return "";
}

function parseSeat(text = "") {
  const raw = normalizeText(text);
  if (raw.includes("우등")) return "우등";
  if (raw.includes("중형")) return "중형";
  if (raw.includes("카운티")) return "카운티";
  if (raw.includes("대형")) return "대형";

  const seatDetail = parseSeatDetail(raw);
  if (seatDetail) {
    const count = Number(seatDetail.replace(/[^0-9]/g, ""));
    if (count >= 40) return "대형";
    if (count > 0) return "중형";
  }

  return "";
}

function parseCarCount(text = "") {
  const raw = normalizeText(text);
  const digit = raw.match(/(\d+)\s*(?:대|台)/);
  if (digit) return Number(digit[1]);

  const koreanNumbers = {
    한: 1,
    두: 2,
    세: 3,
    네: 4,
    다섯: 5,
  };
  const korean = raw.match(/(한|두|세|네|다섯)\s*대/);
  return korean ? koreanNumbers[korean[1]] : "";
}

function parseNights(text = "") {
  const raw = normalizeText(text);
  const nights = raw.match(/(\d+)\s*박/);
  return nights ? Number(nights[1]) : "";
}

function parseRoundTrip(text = "") {
  const raw = normalizeText(text);
  if (raw.includes("편도")) return "편도";
  if (raw.includes("왕복")) return "왕복";
  return "";
}

function cleanPlace(value = "") {
  return String(value || "")
    .replace(/\s*(?:로|으로)?\s*하고\s*$/g, "")
    .replace(/\s*(?:로|으로|까지|행)\s*$/g, "")
    .trim();
}

function parseRoute(text = "") {
  const raw = normalizeText(text);

  const startLabel = raw.match(/출발지(?:가|는|를|은|:|：)?\s*([가-힣A-Za-z0-9\s]+?)(?=\s*(?:그리고|행선지|도착지|목적지|경유지|사용자|전화번호|금액|운행|출발\s*시간|시간|$))/);
  const destinationLabel = raw.match(/(?:행선지|도착지|목적지)(?:가|는|를|은|:|：)?\s*([가-힣A-Za-z0-9\s]+?)(?=\s*(?:그리고|사용자|전화번호|금액|운행|출발\s*시간|시간|버스|차량|$))/);
  if (startLabel || destinationLabel) {
    return {
      start: startLabel ? cleanPlace(startLabel[1]) : "",
      destination: destinationLabel ? cleanPlace(destinationLabel[1]) : "",
    };
  }

  const arrow = raw.match(/(.+?)\s*(?:->|→)\s*(.+?)(?:\s|$)/);
  if (arrow) return { start: cleanPlace(arrow[1]), destination: cleanPlace(arrow[2]) };

  const fromTo = raw.match(/([가-힣A-Za-z0-9\s]+?)에서\s+([가-힣A-Za-z0-9\s]+?)(?:까지|로|으로|행)/);
  if (fromTo) return { start: cleanPlace(fromTo[1]), destination: cleanPlace(fromTo[2]) };

  return {};
}

function parseUser(text = "") {
  const raw = normalizeText(text);
  const user = raw.match(/(?:사용자|고객|예약자)\s*(?:이름|명)?\s*(?:은|는|:|：)?\s*([가-힣A-Za-z0-9\s]{2,20}?)(?=\s*(?:그리고|전화번호|연락처|핸드폰|휴대폰|금액|운행|출발|행선지|도착지|목적지|$))/);
  if (user && !/전화번호|연락처|핸드폰|휴대폰/.test(user[1])) return user[1].trim();
  const groupUser = raw.match(/(?:회사|단체|고객)\s*(?:명|이름)?\s*(?:은|는|:|：)?\s*([가-힣A-Za-z0-9\s]{2,20})/);
  if (groupUser) return groupUser[1].trim();
  return "";
}

function parseReservationSearchUser(text = "") {
  const raw = normalizeText(text);

  const beforeUser = raw.match(/([가-힣A-Za-z0-9]{2,20}?)(?:이|가)?\s*사용자(?:로|로\s*되어\s*있는|로\s*되어있는|인|인\s*예약)?/);
  if (beforeUser) return beforeUser[1].trim();

  const labeled = raw.match(/(?:사용자|고객|예약자)\s*(?:이름|명)?\s*(?:이|가|은|는|:|：)?\s*([가-힣A-Za-z0-9\s]{2,20}?)(?=\s*(?:예약|을|를|찾아|검색|조회|보여|불러|가져와|$))/);
  if (labeled) return cleanKoreanParticle(labeled[1]);

  return parseUser(text);
}

function parseDriverName(text = "") {
  const raw = normalizeText(text);
  const compact = raw.replace(/\s+/g, "");
  const withSuffix = compact.match(/([가-힣A-Za-z]{1,12})기사/);
  if (withSuffix) return withSuffix[1].trim();

  const named = raw.match(/기사\s*[:：]?\s*([가-힣A-Za-z]{1,12})/);
  if (named) return named[1].trim();

  return "";
}

function parseReason(text = "") {
  const raw = normalizeText(text);
  if (/병원|아파|병가/.test(raw)) return "병가";
  if (/사고/.test(raw)) return "사고";
  if (/경조/.test(raw)) return "경조";
  if (/휴무/.test(raw)) return "휴무";
  return "기타";
}

function parseSafetyIssue(text = "") {
  const raw = normalizeText(text);
  return SAFETY_ISSUES.find((issue) => raw.includes(issue)) || "";
}

function parseLabeledValue(text = "", labels = [], stopWords = []) {
  const raw = normalizeText(text);
  const labelPattern = labels.join("|");
  const stopPattern = stopWords.join("|");
  const re = new RegExp(`(?:${labelPattern})\\s*(?:이|가|은|는|을|를|:|：)?\\s*(.+?)(?=\\s*(?:${stopPattern}|$))`);
  const match = raw.match(re);
  return match ? match[1].trim() : "";
}

function cleanKoreanParticle(value = "") {
  return String(value || "")
    .replace(/\s*(?:이고|인데|이며|로|으로|에서|에|가|은|는|을|를|번)\s*$/g, "")
    .trim();
}

function parseSafetyDriverName(text = "") {
  const raw = normalizeText(text);
  const compact = raw.replace(/\s+/g, "");
  const named = compact.match(/이름이([가-힣A-Za-z0-9]{1,20})인기사/);
  if (named) return cleanKoreanParticle(named[1]);

  const afterCarNumber = raw.match(
    /(?:차 번호|차번호|차량 번호|차량번호|자기 차량|자기차량)\s*(?:이|가|은|는|을|를|:|：)?\s*[0-9\s-]{2,}\s*([가-힣A-Za-z]{2,20})(?:님|기사님|기사)?(?:을|를|은|는|이|가)?\s*(?=(?:\d{1,2}\s*월|오늘|내일|모레|일시|날짜|과태료|민원|사고|등록|부과|접수|$))/
  );
  if (afterCarNumber) return cleanKoreanParticle(afterCarNumber[1]);

  const labeled = parseLabeledValue(
    raw,
    ["운전자", "운전자는", "기사", "기사는", "이름", "이름이"],
    ["그리고", "일시", "날짜", "장소", "상대", "개요", "형태", "차", "차량", "민원", "사고", "과태료", "등록", "저장"]
  );
  if (labeled) return cleanKoreanParticle(labeled.replace(/\s*기사\s*$/, ""));

  return parseDriverName(raw);
}

function parseSafetyCarNumber(text = "") {
  const raw = normalizeText(text);
  const numericPlate = raw.match(
    /(?:차 번호|차번호|차량 번호|차량번호|자기 차량|자기차량|내 차량|내차량|내 차|내차)\s*(?:이|가|은|는|을|를|:|：)?\s*([0-9\s-]{2,})/
  );
  if (numericPlate) return normalizeSafetyOwnVehicleNumber(numericPlate[1]);

  const labeled = parseLabeledValue(
    raw,
    ["차 번호", "차번호", "차량 번호", "차량번호", "자기 차량", "자기차량", "내 차량", "내차량", "내 차", "내차"],
    ["그리고", "이름", "기사", "운전자", "일시", "날짜", "장소", "상대", "개요", "형태", "민원", "사고", "과태료", "등록"]
  );
  if (labeled) return normalizeSafetyOwnVehicleNumber(labeled);

  const compactDigits = raw.match(/(?:차 번호|차번호|차량 번호|차량번호)\s*(?:이|가|은|는|:|：)?\s*([0-9\s-]{4,})/);
  if (compactDigits) return compactDigits[1].replace(/\D/g, "").slice(-4);

  return "";
}

function parseSafetyPlace(text = "") {
  const raw = normalizeText(text);
  const place = parseLabeledValue(
    raw,
    ["장소"],
    ["상대", "상대 차량", "개요", "요약", "내용", "등록"]
  );
  return cleanKoreanParticle(place);
}

function parseSafetyOpponent(text = "") {
  const raw = normalizeText(text);
  const opponent = parseLabeledValue(
    raw,
    ["상대 차량", "상대차량", "상대 차", "상대차"],
    ["그리고", "내 차량", "내차량", "내 차", "내차", "자기 차량", "자기차량", "운전자", "기사", "형태", "일시", "날짜", "장소", "개요", "요약", "내용", "보험", "처리", "등록", "저장"]
  );
  return normalizeVehiclePlateText(cleanKoreanParticle(opponent));
}

function parseSafetySummary(text = "") {
  const raw = normalizeText(text);
  const summary = parseLabeledValue(
    raw,
    ["개요", "요약", "내용"],
    ["보험", "처리", "지급", "금액", "등록"]
  );
  if (summary) {
    return summary
      .replace(/\s*(?:이라고|라고)\s*(?:해서|등록|저장|처리)?(?:해\s*줘|해줘|해\s*주세요|해주세요)?\s*$/g, "")
      .replace(/\s*(?:으로|로)\s*(?:등록|처리|저장)?(?:해\s*줘|해줘|해\s*주세요|해주세요)?\s*$/g, "")
      .replace(/\s*(?:등록|저장|처리)(?:해\s*줘|해줘|해\s*주세요|해주세요)?\s*$/g, "")
      .trim();
  }
  if (raw.includes("민원")) return "민원 접수";
  if (raw.includes("사고")) return "사고 접수";
  if (raw.includes("과태료")) return "과태료 접수";
  return "";
}

function parseExpenseCarNumber(text = "") {
  const raw = normalizeText(text);
  const labeled = raw.match(/(?:차량번호|차량 번호|차 번호|차번호)\s*(?:가|는|를|은|:|：)?\s*([0-9\s-]{2,})/);
  if (labeled) return labeled[1].replace(/\D/g, "").slice(-4);
  return "";
}

function normalizeSpokenDigits(value = "") {
  return String(value || "").replace(/\D/g, "");
}

function parseVehicleTargetCarNumber(text = "") {
  const raw = normalizeText(text);
  const match = raw.match(/(?:차량번호|차량 번호|차 번호|차번호)\s*(?:가|는|를|은|:|：)?\s*([0-9\s-]{2,})/);
  if (!match) return "";
  return normalizeSpokenDigits(match[1]).slice(-4);
}

function normalizeVehicleNumber(value = "") {
  return String(value || "")
    .replace(/\s+/g, "")
    .replace(/[^0-9가-힣A-Za-z]/g, "");
}

function normalizeVehiclePlateText(value = "") {
  return normalizeVehicleNumber(value)
    .replace(/^이사가(?=\d)/, "24가")
    .replace(/^이사(?=\d)/, "24")
    .replace(/야$/g, "");
}

function normalizeSafetyOwnVehicleNumber(value = "") {
  const normalized = normalizeVehiclePlateText(value);
  if (!normalized) return "";
  if (/^\d+$/.test(normalized)) return normalized.slice(0, 4);
  return normalized;
}

function parseVehicleNumber(text = "") {
  const raw = normalizeText(text);
  const match = raw.match(/(?:차량번호|차량 번호|차 번호|차번호)\s*(?:가|는|를|은|:|：)?\s*([0-9가-힣A-Za-z\s-]{2,20}?)(?=\s*(?:그리고|차명|차 이름|차량명|기사명|기사 이메일|기사메일|핸드폰|휴대폰|전화번호|연식|년식|승차|경력|이렇게|등록|추가|$))/);
  if (!match) return "";
  return normalizeVehicleNumber(cleanTrailingParticle(match[1]));
}

const SPOKEN_EMAIL_WORDS = [
  ["이그잼플", "example"],
  ["이그잠플", "example"],
  ["익잼플", "example"],
  ["익잠플", "example"],
  ["드라이버", "driver"],
  ["어드민", "admin"],
  ["테스트", "test"],
  ["유저", "user"],
  ["사용자", "user"],
  ["구글메일", "gmail"],
  ["지메일", "gmail"],
  ["쥐메일", "gmail"],
  ["구글", "google"],
  ["네이버", "naver"],
  ["다음", "daum"],
  ["한메일", "hanmail"],
  ["카카오", "kakao"],
  ["야후", "yahoo"],
  ["아웃룩", "outlook"],
  ["핫메일", "hotmail"],
  ["컴", "com"],
  ["넷", "net"],
  ["오알지", "org"],
  ["코", "co"],
  ["케이알", "kr"],
  ["언더바", "_"],
  ["언더스코어", "_"],
  ["하이픈", "-"],
  ["대시", "-"],
  ["플러스", "+"],
  ["더블유", "w"],
  ["에이치", "h"],
  ["에프", "f"],
  ["에스", "s"],
  ["엑스", "x"],
  ["와이", "y"],
  ["제트", "z"],
  ["에이", "a"],
  ["비", "b"],
  ["씨", "c"],
  ["시", "c"],
  ["디", "d"],
  ["이", "e"],
  ["지", "g"],
  ["아이", "i"],
  ["제이", "j"],
  ["케이", "k"],
  ["엘", "l"],
  ["엠", "m"],
  ["엔", "n"],
  ["오", "o"],
  ["피", "p"],
  ["큐", "q"],
  ["알", "r"],
  ["티", "t"],
  ["유", "u"],
  ["브이", "v"],
];

const HANGUL_INITIAL_ROMAJA = ["g", "kk", "n", "d", "tt", "r", "m", "b", "pp", "s", "ss", "", "j", "jj", "ch", "k", "t", "p", "h"];
const HANGUL_MEDIAL_ROMAJA = ["a", "ae", "ya", "yae", "eo", "e", "yeo", "ye", "o", "wa", "wae", "oe", "yo", "u", "wo", "we", "wi", "yu", "eu", "ui", "i"];
const HANGUL_FINAL_ROMAJA = ["", "k", "k", "ks", "n", "nj", "nh", "t", "l", "lk", "lm", "lb", "ls", "lt", "lp", "lh", "m", "p", "ps", "t", "t", "ng", "t", "t", "k", "t", "p", "t"];

function romanizeHangulForEmail(value = "") {
  return String(value || "").replace(/[가-힣]/g, (char) => {
    const code = char.charCodeAt(0) - 0xac00;
    if (code < 0 || code > 11171) return "";
    const initial = Math.floor(code / 588);
    const medial = Math.floor((code % 588) / 28);
    const final = code % 28;
    return `${HANGUL_INITIAL_ROMAJA[initial]}${HANGUL_MEDIAL_ROMAJA[medial]}${HANGUL_FINAL_ROMAJA[final]}`;
  });
}

function normalizeSpokenEmail(value = "") {
  let email = String(value || "").toLowerCase().trim();
  email = email
    .replace(/\s*(?:골뱅이|앳|엣)\s*/g, "@")
    .replace(/\s*(?:닷|점)\s*(?:컴|com)\b/g, ".com")
    .replace(/\s*(?:닷|점)\s*/g, ".")
    .replace(/\s*@\s*/g, "@")
    .replace(/\s*\.\s*/g, ".");

  [...SPOKEN_EMAIL_WORDS].sort((a, b) => b[0].length - a[0].length).forEach(([ko, en]) => {
    email = email.replace(new RegExp(ko, "g"), en);
  });

  email = email.replace(
    /(\.(?:com|net|org|co|kr))\s*(?:으로|로)?\s*(?:해\s*주고|해\s*줘|해줘|해\s*주세요|해주세요|이고|이며|입니다|이에요|예요|야|이야)?\s*$/g,
    "$1"
  );
  email = romanizeHangulForEmail(email);

  return email
    .replace(/\s+/g, "")
    .replace(/\.(?:com|net|org|co|kr)(?:으로|로|이고|이며|입니다|이에요|예요|야|이야)?$/g, (match) =>
      match.replace(/(?:으로|로|이고|이며|입니다|이에요|예요|야|이야)$/g, "")
    )
    .replace(/[，,;；]+$/g, "")
    .replace(/[^a-z0-9._%+\-@]/g, "")
    .trim();
}

function parseLabeledVehicleValue(text = "", labels = [], stopLabels = []) {
  const raw = normalizeText(text);
  const labelPattern = labels.map((label) => label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const stopPattern = stopLabels.map((label) => label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const re = new RegExp(`(?:${labelPattern})\\s*(?:은|는|이|가|을|를|:|：)?\\s*(.+?)(?=\\s*(?:그리고|${stopPattern}|이렇게|등록|추가|$))`);
  const match = raw.match(re);
  return match ? cleanTrailingParticle(match[1]) : "";
}

function parseVehicleCreateFields(text = "") {
  const stopLabels = VEHICLE_UPDATE_FIELDS.flatMap((field) => field.labels);
  const carNumber = parseVehicleNumber(text);
  const driverEmail = normalizeSpokenEmail(
    parseLabeledVehicleValue(text, ["기사 이메일", "기사메일", "기사 메일", "이메일", "메일"], stopLabels)
  );
  const phone = parsePhoneLike(parseLabeledVehicleValue(text, ["핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "전화번호", "연락처"], stopLabels));
  const yearValue = parseLabeledVehicleValue(text, ["년식", "연식"], stopLabels);

  return {
    car_number: carNumber,
    car_name: normalizeVehicleTextValue(parseLabeledVehicleValue(text, ["차명", "차 이름", "차량명", "차량 이름"], stopLabels), "car_name"),
    driver: parseLabeledVehicleValue(text, ["기사명", "기사 이름", "기사", "운전자"], stopLabels),
    driver_email: driverEmail,
    phone,
    year: normalizeSpokenDigits(yearValue),
    seat: parseLabeledVehicleValue(text, ["승차인원", "승차 인원", "좌석", "인승"], stopLabels),
    career: parseLabeledVehicleValue(text, ["경력사항", "경력 사항", "경력"], stopLabels),
    car_number_only: carNumber ? carNumber.slice(-4) : "",
  };
}

function parsePhoneLike(value = "") {
  const match = String(value || "").match(/01[016789][0-9-\s]{7,16}/);
  if (!match) return "";
  const digits = match[0].replace(/\D/g, "");
  if (digits.length === 11) return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  return match[0].replace(/\s+/g, "");
}

function cleanChangeValue(value = "") {
  return String(value || "")
    .replace(/\s*(?:이라고|라고)\s*(?:되어\s*있는데|돼\s*있는데)?/g, "")
    .replace(/\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐).*$/g, "")
    .replace(/\s*(?:바꿔|바꾸|변경|수정|고쳐).*$/g, "")
    .replace(/\s*(?:해줘|해주세요|줘)\s*$/g, "")
    .trim();
}

function normalizeVehicleTextValue(value = "", key = "") {
  const cleaned = cleanChangeValue(value);
  if (key === "car_name") {
    return cleaned.replace(/([가-힣A-Za-z])\s+(\d+)$/g, "$1$2");
  }
  return cleaned;
}

function parseVehicleChangeValue(segment = "", key = "") {
  const raw = normalizeText(segment);

  if (key === "phone") {
    const phones = raw.match(/01[016789][0-9-\s]{6,12}/g) || [];
    if (phones.length > 0) return phones[phones.length - 1].replace(/\s+/g, "");
  }

  if (key === "car_number") {
    const numbers = raw.match(/[0-9\s-]{2,}/g) || [];
    if (numbers.length > 1) return normalizeSpokenDigits(numbers[numbers.length - 1]);
  }

  const fromTo = raw.match(/(.+?)\s*에서\s*(.+?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (fromTo) return normalizeVehicleTextValue(fromTo[2], key);

  const afterThis = raw.match(/(?:이거를|이걸|이것을|이거|그거를|그걸)\s*(.+?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (afterThis) return normalizeVehicleTextValue(afterThis[1], key);

  const oldNew = raw.match(/(?:을|를)\s*(.+?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (oldNew) return normalizeVehicleTextValue(oldNew[1], key);

  const direct = raw.match(/(.+?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (direct) return normalizeVehicleTextValue(direct[1], key);

  return "";
}

function parseVehicleUpdates(text = "") {
  const raw = normalizeText(text);
  const updates = {};
  const expected_before = {};
  const fieldStopLabels = VEHICLE_UPDATE_FIELDS.flatMap((field) => field.labels)
    .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");

  VEHICLE_UPDATE_FIELDS.forEach(({ key, labels }) => {
    for (const label of labels) {
      const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const re = new RegExp(`(?:${escaped})\\s*(?:을|를|은|는|이|가|:|：)?\\s*(.+?)(?=\\s*(?:그리고|${fieldStopLabels}|$))`);
      const match = raw.match(re);
      if (!match) continue;

      const value = parseVehicleChangeValue(match[1], key);
      if (!value) continue;

      if (key === "phone") updates[key] = parsePhoneLike(value) || value;
      else if (key === "car_number") updates[key] = normalizeSpokenDigits(value);
      else if (key === "year") updates[key] = normalizeSpokenDigits(value) || value;
      else updates[key] = value;
      return;
    }
  });

  const carNameChangeCandidates = [...raw.matchAll(/차명/g)]
    .map((match) => raw.slice(match.index))
    .map((segment) =>
      segment.match(/^차명\s*(?:을|를|은|는|이|가)?\s*(.+?)\s*(?:에서|을|를)\s*(.+?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/)
    )
    .filter(Boolean)
    .map((match) => ({
      before: normalizeVehicleTextValue(match[1], "car_name"),
      after: normalizeVehicleTextValue(match[2], "car_name"),
    }))
    .filter(
      (item) =>
        item.before &&
        item.after &&
        !/차명|수정|바꿔|변경|고쳐/.test(item.before) &&
        !/차명|수정|바꿔|변경|고쳐|핸드폰|휴대폰|전화번호|연락처/.test(item.after)
    );

  const carNameBefore = carNameChangeCandidates[carNameChangeCandidates.length - 1];
  if (carNameBefore) {
    expected_before.car_name = carNameBefore.before;
    updates.car_name = carNameBefore.after;
  }

  const phoneBefore = raw.match(/(?:핸드폰 번호|핸드폰|휴대폰 번호|휴대폰|전화번호|연락처)\s*(?:을|를|은|는)?\s*(01[016789][0-9-\s]{6,12}).*?(?:이거를|이걸|이것을)?\s*(01[016789][0-9-\s]{6,12})\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (phoneBefore) {
    expected_before.phone = phoneBefore[1].replace(/\s+/g, "");
    updates.phone = phoneBefore[2].replace(/\s+/g, "");
  }

  return { updates, expected_before };
}

function parseDriverTarget(text = "") {
  const raw = normalizeText(text);
  const target = {};

  const emailMatch = raw.match(
    /(?:기사 이메일|기사메일|기사 메일|이메일|메일)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:이\s*기사|그\s*기사|기사명|기사\s*전화번호|핸드폰|휴대폰|전화번호|연락처|정보|수정|등록|추가|$))/
  );
  if (emailMatch) target.target_email = normalizeSpokenEmail(emailMatch[1]);

  const nameMatch = raw.match(
    /(?:기사명|기사 이름|운전자명|운전자 이름)(?:\s*(?:은|는|이|가|을|를|:|：)\s+|\s+)([가-힣A-Za-z0-9]{2,20})(?=\s*(?:기사\s*이메일|기사메일|이메일|메일|이\s*기사|그\s*기사|정보|수정|핸드폰|휴대폰|전화번호|연락처|$))/
  );
  if (nameMatch && !/정보|수정|변경|핸드폰|휴대폰|전화번호|연락처/.test(nameMatch[1])) {
    target.target_driver_name = nameMatch[1].trim();
  }

  return target;
}

function normalizeDriverChangeValue(value = "", key = "") {
  if (key === "email") return normalizeSpokenEmail(value);
  if (key === "phone") return parsePhoneLike(value) || String(value || "").replace(/\s+/g, "").trim();
  return cleanChangeValue(value);
}

function parseDriverUpdates(text = "") {
  const raw = normalizeText(text);
  const updates = {};
  const expected_before = {};
  const fieldStopLabels = DRIVER_UPDATE_FIELDS.flatMap((field) => field.labels)
    .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");

  DRIVER_UPDATE_FIELDS.forEach(({ key, labels }) => {
    for (const label of labels) {
      const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const re = new RegExp(`(?:${escaped})\\s*(?:을|를|은|는|이|가|:|：)?\\s*(.+?)(?=\\s*(?:그리고|${fieldStopLabels}|$))`);
      const match = raw.match(re);
      if (!match) continue;

      const value = parseVehicleChangeValue(match[1], key);
      if (!value) continue;

      updates[key] = normalizeDriverChangeValue(value, key);
      return;
    }
  });

  const nameBefore = raw.match(
    /(?:기사명|기사 이름|운전자명|운전자 이름)\s*(?:을|를|은|는|이|가)?\s*([가-힣A-Za-z0-9\s]{2,20}?)\s*에서\s*([가-힣A-Za-z0-9\s]{2,20}?)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/
  );
  if (nameBefore) {
    expected_before.driver_name = cleanChangeValue(nameBefore[1]);
    updates.driver_name = cleanChangeValue(nameBefore[2]);
  }

  const emailBefore = raw.match(
    /(?:기사 이메일|기사메일|기사 메일|이메일|메일)\s*(?:을|를|은|는|이|가)?\s*([^\s]+(?:\s*골뱅이\s*|\s*@\s*)[^\s]+).*?(?:이거를|이걸|이것을|그거를|그걸)?\s*([^\s]+(?:\s*골뱅이\s*|\s*@\s*)[^\s]+)\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/
  );
  if (emailBefore) {
    expected_before.email = normalizeSpokenEmail(emailBefore[1]);
    updates.email = normalizeSpokenEmail(emailBefore[2]);
  }

  const phoneBefore = raw.match(/(?:핸드폰 번호|핸드폰|휴대폰 번호|휴대폰|전화번호|연락처)\s*(?:을|를|은|는|이|가)?\s*(?:지금\s*)?(01[016789][0-9-\s]{6,12}).*?(?:이거를|이걸|이것을|그거를|그걸)?\s*(01[016789][0-9-\s]{6,12})\s*(?:으로|로)\s*(?:바꿔|바꾸|변경|수정|고쳐)/);
  if (phoneBefore) {
    expected_before.phone = phoneBefore[1].replace(/\s+/g, "");
    updates.phone = phoneBefore[2].replace(/\s+/g, "");
  }

  Object.keys(updates).forEach((key) => {
    if (!updates[key]) delete updates[key];
  });

  return { updates, expected_before };
}

function parseDriverCreateFields(text = "") {
  const stopLabels = DRIVER_CREATE_FIELDS.flatMap((field) => field.labels);
  const nameMatch = normalizeText(text).match(
    /(?:기사명|기사 이름|운전자명|운전자 이름)(?:\s*(?:은|는|이|가|을|를|:|：)\s+|\s+)([가-힣A-Za-z0-9]{2,20})(?=\s*(?:기사\s*이메일|기사메일|이메일|메일|기사\s*전화번호|기사전화번호|핸드폰|휴대폰|전화번호|연락처|경력사항|경력|등록|추가|$))/
  );
  const emailMatch = normalizeSpokenEmail(
    parseLabeledVehicleValue(text, ["기사 이메일", "기사메일", "기사 메일", "이메일", "메일"], stopLabels)
  );
  const phone = parsePhoneLike(
    parseLabeledVehicleValue(text, ["기사 전화번호", "기사전화번호", "핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "전화번호", "연락처"], stopLabels)
  );

  return {
    driver_name: nameMatch ? nameMatch[1].trim() : parseLabeledVehicleValue(text, ["기사명", "기사 이름", "운전자명", "운전자 이름"], stopLabels),
    email: emailMatch,
    phone,
    career: parseLabeledVehicleValue(text, ["경력사항", "경력 사항", "경력"], stopLabels),
    note: text,
  };
}

function parseUserCreateValue(text = "", labels = [], stopLabels = []) {
  const value = parseLabeledVehicleValue(text, labels, stopLabels);
  return String(value || "")
    .replace(/^이메일\s*(?:은|는|이|가|을|를|:|：)?\s*/g, "")
    .trim();
}

function parseUserSystem(text = "") {
  const raw = normalizeText(text);
  if (/전체/.test(raw)) return "전체";
  if (/배차\s*담당|배차담당/.test(raw)) return "배차담당";
  if (/차고\s*관리|차고관리/.test(raw)) return "차고관리";
  if (/기사/.test(raw)) return "기사";
  return "기사";
}

function parseUserCreateFields(text = "") {
  const stopLabels = USER_CREATE_FIELDS.flatMap((field) => field.labels);
  const raw = normalizeText(text);
  const branchMatch = raw.match(/(?:지점명|지점)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:팀명|팀|직위명|직위|이메일|메일|전화번호|전화|핸드폰|휴대폰|주소|등록|$))/);
  const teamMatch = raw.match(/(?:팀명|팀)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:직위명|직위|이메일|메일|전화번호|전화|핸드폰|휴대폰|주소|등록|$))/);
  const positionMatch = raw.match(/(?:직위명|직위)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:이메일|메일|전화번호|전화|핸드폰|휴대폰|주소|등록|$))/);
  const emailMatches = [
    ...raw.matchAll(
      /(?:이메일|메일|Email|email)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:전화번호|전화|핸드폰|휴대폰|연락처|주소|등록|$))/gi
    ),
  ];
  const emailRaw = emailMatches.length
    ? emailMatches[emailMatches.length - 1][1]
    : parseUserCreateValue(text, ["이메일", "메일", "Email", "email"], stopLabels);
  const phone = parsePhoneLike(
    parseUserCreateValue(text, ["전화번호", "전화", "핸드폰 번호", "핸드폰", "휴대폰 번호", "휴대폰", "연락처"], stopLabels)
  );

  return {
    name: parseUserCreateValue(text, ["이름", "사용자명", "사용자 이름"], stopLabels),
    user_id: parseUserCreateValue(text, ["사용자 아이디", "사용자 ID", "사용자 id", "아이디", "ID", "id"], stopLabels),
    password: parseUserCreateValue(text, ["비밀번호", "패스워드", "비번"], stopLabels).replace(/\s+/g, ""),
    system: parseUserCreateValue(text, ["사용 시스템", "시스템", "권한"], stopLabels) || parseUserSystem(text),
    branch: branchMatch ? cleanTrailingParticle(branchMatch[1]) : parseUserCreateValue(text, ["지점명", "지점"], stopLabels),
    team: teamMatch ? cleanTrailingParticle(teamMatch[1]) : parseUserCreateValue(text, ["팀명", "팀"], stopLabels),
    position: positionMatch ? cleanTrailingParticle(positionMatch[1]) : parseUserCreateValue(text, ["직위명", "직위"], stopLabels),
    email: normalizeSpokenEmail(
      String(emailRaw || "").replace(/^(?:이메일|메일)?\s*(?:은|는|이|가|을|를|:|：)?\s*/g, "")
    ),
    phone,
    address: parseUserCreateValue(text, ["주소"], stopLabels),
    note: text,
  };
}

function cleanBugReportText(value = "") {
  return String(value || "")
    .replace(/[，,.;；。]+$/g, "")
    .replace(/\s*(?:이고|이고,|이며|이며,)\s*$/g, "")
    .replace(/\s*(?:라고|이라고)\s*(?:써줘|써\s*줘|작성해\s*줘|등록해\s*줘|해\s*줘)?\s*$/g, "")
    .replace(/\s*(?:써줘|써\s*줘|작성해\s*줘|등록해\s*줘|해\s*줘)\s*$/g, "")
    .replace(/[，,.;；。]+$/g, "")
    .trim();
}

function parseBugReportFields(text = "") {
  const raw = normalizeText(text);
  const titleMatch = raw.match(/(?:제목|타이틀)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+?)(?=\s*(?:내용|본문|$))/);
  const contentMatch = raw.match(/(?:내용|본문)\s*(?:은|는|이|가|을|를|:|：)?\s*(.+)$/);

  return {
    title: cleanBugReportText(titleMatch?.[1] || ""),
    content: cleanBugReportText(contentMatch?.[1] || ""),
    note: text,
  };
}

function parseExpenseDriverName(text = "") {
  const raw = normalizeText(text);
  const driverLabel = raw.match(/기사명\s*(?:은|는|:|：)?\s*([가-힣A-Za-z]{2,20})/);
  if (driverLabel) return cleanKoreanParticle(driverLabel[1]);

  const withSuffix = raw.match(/([가-힣A-Za-z]{2,20})\s*기사(?:님)?/);
  if (withSuffix) return cleanKoreanParticle(withSuffix[1]);

  const withNim = raw.match(/(?:가진\s*)?([가-힣A-Za-z]{2,20})\s*님(?:의)?/);
  if (withNim && !["기사", "운전자"].includes(withNim[1])) return cleanKoreanParticle(withNim[1]);

  const labeled = raw.match(/(?:기사명|기사|운전자)\s*(?:이|가|은|는|:|：)?\s*([가-힣A-Za-z]{2,20})/);
  if (labeled) return cleanKoreanParticle(labeled[1]);

  return "";
}

function parseExpenseAmounts(text = "") {
  return EXPENSE_FIELD_LABELS.reduce((acc, item) => {
    acc[item.key] = parseLabeledMoney(text, item.labels);
    return acc;
  }, {});
}

function hasAnyExpenseAmount(command = {}) {
  return EXPENSE_FIELD_LABELS.some(({ key }) => Number(command[key]) > 0);
}

export function detectIntent(text = "") {
  const raw = normalizeText(text);
  const hasSafetyContext = /안전\s*관리|안전관리|민원|사고|상대\s*차량|상대차량/.test(raw);
  const hasVehicleCreate = /차량\s*추가|차량\s*추가\s*등록|차량\s*등록|차량정보\s*등록|차량\s*정보\s*등록|차량\s*정보(?:에서)?\s*차\s*(?:를)?\s*(?:한\s*대|1\s*대)?\s*추가|차\s*(?:를)?\s*(?:한\s*대|1\s*대)?\s*추가/.test(raw);
  const hasVehicleUpdate = /차량\s*정보|차량정보|차량\s*수정|차량\s*정보\s*수정|차명|기사\s*이메일|승차\s*인원|경력\s*사항/.test(raw);
  const hasBugReport = /버그\s*신고|버그신고|오류\s*신고|오류신고/.test(raw);
  const hasUserCreate = /사용자\s*추가|사용자\s*등록|사용자\s*추가\s*등록|사용자관리|사용자\s*관리/.test(raw);
  const hasDriverCreate = /기사\s*추가|기사\s*등록|기사\s*추가\s*등록|기사정보\s*등록|기사\s*정보\s*등록|운전자\s*추가|운전자\s*등록/.test(raw);
  const hasDriverUpdate = /기사\s*정보|기사정보|기사\s*정보\s*수정|기사\s*수정|운전자\s*정보|운전자정보/.test(raw);
  const hasExpenseContext = /지출|지출\s*내역|매출\s*관리/.test(raw);
  const hasSafety = hasSafetyContext || /과태료/.test(raw);
  const hasExpense = hasExpenseContext || /주차료|주차비|숙식비|숙박비|식비|통행료|주유비|정비비|세차료|출장비|조합비|운영비|할부금|급여|보험료|GPS|지피에스|4대\s*보험|사대\s*보험|과태료/.test(raw);
  const hasReservation = /예약|배차|운행/.test(raw);
  const hasCreate = /넣어|등록|저장|작성|잡아|추가|만들|생성/.test(raw);
  const hasUpdate = /수정|바꿔|바꾸|변경|고쳐/.test(raw);
  const hasSearch = SEARCH_WORDS.some((word) => raw.includes(word));
  const hasChange = CHANGE_WORDS.some((word) => raw.includes(word));
  const hasLeave = LEAVE_WORDS.some((word) => raw.includes(word));

  if (hasBugReport && (hasCreate || /제목|내용|본문|써줘|써\s*줘|작성/.test(raw))) return "bug_report_create_draft";
  if (hasUserCreate && hasCreate) return "user_create_draft";
  if (hasDriverCreate && hasCreate) return "driver_create_draft";
  if (hasVehicleCreate && hasCreate) return "vehicle_create_draft";
  if (hasDriverUpdate && hasUpdate) return "driver_update_draft";
  if (hasVehicleUpdate && hasUpdate) return "vehicle_update_draft";
  if (hasExpense && hasCreate && (hasExpenseContext || !hasSafetyContext)) return "expense_create_draft";
  if (hasSafety && hasCreate) return "safety_create_draft";
  if (hasReservation && hasSearch && !hasCreate && !hasChange) return "reservation_search";
  if (hasReservation && hasCreate && !hasChange) return "create_reservation_draft";
  if ((hasChange || hasLeave) && /기사|운전/.test(raw)) return "driver_change_draft";
  return "unknown";
}

export function missingFieldsForCommand(intent, command = {}) {
  if (intent === "create_reservation_draft") {
    return [
      ["reservation_type", "예약 유형"],
      ["date", "운행일"],
      ["time", "출발시간"],
      ["start", "출발지"],
      ["destination", "행선지"],
      ["user", "사용자"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "driver_change_draft") {
    return [
      ["from_driver_name", "기존 기사명"],
      ["date", "변경 대상일"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "safety_create_draft") {
    return [
      ["issue", "형태"],
      ["driver_name", "운전자"],
      ["date", "일시"],
      ["summary", "개요"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "reservation_search") {
    return [["date", "운행일"]]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "expense_create_draft") {
    const missing = [];
    if (!command.date) missing.push("지출일");
    if (!command.car_number) missing.push("차량번호");
    if (!hasAnyExpenseAmount(command)) missing.push("지출 항목/금액");
    return missing;
  }

  if (intent === "vehicle_update_draft") {
    const missing = [];
    if (!command.target_car_number) missing.push("대상 차량번호");
    if (!command.updates || Object.keys(command.updates).length === 0) missing.push("수정할 항목");
    return missing;
  }

  if (intent === "driver_update_draft") {
    const missing = [];
    if (!command.target_driver_name && !command.target_email) missing.push("대상 기사명 또는 기사 이메일");
    if (!command.updates || Object.keys(command.updates).length === 0) missing.push("수정할 항목");
    return missing;
  }

  if (intent === "driver_create_draft") {
    return [
      ["driver_name", "기사명"],
      ["phone", "기사 전화번호"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "user_create_draft") {
    return [
      ["name", "이름"],
      ["user_id", "사용자 아이디"],
      ["password", "비밀번호"],
      ["branch", "지점명"],
      ["team", "팀명"],
      ["position", "직위명"],
      ["email", "이메일"],
      ["phone", "전화번호"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "bug_report_create_draft") {
    return [
      ["title", "제목"],
      ["content", "내용"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  if (intent === "vehicle_create_draft") {
    return [
      ["car_number", "차량번호"],
    ]
      .filter(([key]) => !command[key])
      .map(([, label]) => label);
  }

  return [];
}

export function mergeCommand(base = {}, next = {}) {
  const merged = { ...base };
  Object.entries(next || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") merged[key] = value;
  });
  return merged;
}

export function parseAiOpsText(text = "", options = {}) {
  const baseDate = options.baseDate || new Date();
  const previousCommand = options.previousCommand || {};
  const detectedIntent = detectIntent(text);
  const intent = detectedIntent === "unknown" ? options.previousIntent || "unknown" : detectedIntent;
  const route = parseRoute(text);

  let command = {};

  if (intent === "create_reservation_draft") {
    command = {
      reservation_type: parseReservationType(text),
      date: parseKoreanDate(text, baseDate),
      time: parseKoreanTime(text),
      start: route.start || "",
      transit: "",
      destination: route.destination || "",
      user: parseUser(text),
      user_phone: parseUserPhone(text),
      money: parseMoney(text),
      buses: parseCarCount(text) || 1,
      nights: parseNights(text) || 0,
      round: parseRoundTrip(text) || "왕복",
      seat: parseSeat(text),
      seat_detail: parseSeatDetail(text),
      car_number: "",
      note: text,
    };
  }

  if (intent === "driver_change_draft") {
    command = {
      from_driver_name: parseDriverName(text),
      date: parseKoreanDate(text, baseDate),
      reason: parseReason(text),
      requested_change: text,
    };
  }

  if (intent === "safety_create_draft") {
    command = {
      issue: parseSafetyIssue(text),
      driver_name: parseSafetyDriverName(text),
      car_number: parseSafetyCarNumber(text),
      date: parseKoreanDate(text, baseDate),
      time: parseKoreanTime(text) || "00:00",
      place: parseSafetyPlace(text),
      opponent: parseSafetyOpponent(text),
      summary: parseSafetySummary(text),
      insurance: "",
      process: "",
      etc: "",
      surcharge: "",
    };
  }

  if (intent === "reservation_search") {
    command = {
      date: parseKoreanDate(text, baseDate),
      reservation_type: parseReservationType(text),
      user: parseReservationSearchUser(text),
      start: route.start || "",
      destination: route.destination || "",
      note: text,
    };
  }

  if (intent === "expense_create_draft") {
    command = {
      date: parseKoreanDate(text, baseDate),
      car_number: parseExpenseCarNumber(text),
      human_name: parseExpenseDriverName(text),
      ...parseExpenseAmounts(text),
      bigo: text,
    };
  }

  if (intent === "vehicle_update_draft") {
    const parsed = parseVehicleUpdates(text);
    command = {
      target_car_number: parseVehicleTargetCarNumber(text),
      updates: parsed.updates,
      expected_before: parsed.expected_before,
      note: text,
    };
  }

  if (intent === "driver_update_draft") {
    const parsed = parseDriverUpdates(text);
    command = {
      ...parseDriverTarget(text),
      updates: parsed.updates,
      expected_before: parsed.expected_before,
      note: text,
    };
  }

  if (intent === "driver_create_draft") {
    command = parseDriverCreateFields(text);
  }

  if (intent === "user_create_draft") {
    command = parseUserCreateFields(text);
  }

  if (intent === "bug_report_create_draft") {
    command = parseBugReportFields(text);
  }

  if (intent === "vehicle_create_draft") {
    command = {
      ...parseVehicleCreateFields(text),
      note: text,
    };
  }

  const mergedCommand = mergeCommand(previousCommand, command);
  const missing_fields = missingFieldsForCommand(intent, mergedCommand);

  return {
    intent,
    confidence: detectedIntent === "unknown" ? 0.25 : 0.65,
    command: mergedCommand,
    missing_fields,
    reply:
      intent === "unknown"
        ? "예약 등록, 예약 검색, 기사 변경, 안전관리 등록, 지출 등록, 차량 정보 수정/추가, 기사 정보 수정/추가, 사용자 추가, 버그 신고 요청으로 이해할 수 있게 조금 더 구체적으로 말씀해 주세요."
        : missing_fields.length
        ? `필수 정보가 더 필요합니다: ${missing_fields.join(", ")}`
        : intent === "reservation_search"
        ? "예약 검색 화면으로 이동할 수 있습니다."
        : "초안을 만들 수 있습니다.",
    source: "local-parser",
    supported_reservation_types: RESERVATION_TYPES,
  };
}
